
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/circleci",
      function () {
        return require("private-next-pages/services/circleci/index.tsx");
      }
    ]);
  